export const ENTRY_TYPES = {
  JOURNAL: 'journal',
  NODE: 'node',
}
